<tm-modal [modalConfig]="{width: '300px', position: { top: '50vh' }}" title="{{'socialShareModal' | translate}}" panelClass="share-social-modal" #modal>
  <tm-modal-header></tm-modal-header>
  <tm-modal-body>
    <div class="f3f3f3" #tmModalBody>
      <div class="col-md-12 social">
        <ul>
          <li><a href="javascript: void(0)" role="button" (click)="logtoGA('fb'); share2FB()"
            title="{{'shareTo' | translate: ({value: 'FB'})}}[{{'openNewWindow' | translate}}]">
            <i class="fa fa-lg fa-facebook"></i>
            <span class="sr-only">{{'shareTo' | translate: ({value: 'FB'})}}</span>
          </a></li>
          <li><a href="javascript: void(0)" role="button" tmShareTwitter (click)="logtoGA('twitter')"
            title="{{'shareTo' | translate: ({value: 'Twitter'})}}[{{'openNewWindow' | translate}}]">
            <i class="fa fa-lg fa-twitter"></i>
            <span class="sr-only">{{'shareTo' | translate: ({value: 'Twitter'})}}</span>
          </a></li>
          <li><a href="javascript: void(0)" role="button" tmShareLine (click)="logtoGA('line')"
            title="{{'shareTo' | translate: ({value: 'Line'})}}[{{'openNewWindow' | translate}}]" class="line">
            <i class="fa fa-lg icon-line" aria-hidden="true"></i>
            <span class="sr-only">{{'shareTo' | translate: ({value: 'Line'})}}</span>
          </a></li>
          <li>
            <!-- <g:sharetoclassroom url="{{pageUrl}}" size="32"></g:sharetoclassroom> -->
            <!-- <div class="g-sharetoclassroom" data-size="32" attr.data-url="{{pageUrl}}" ></div> -->
            <div class="google-classroom-share" [tmShareGoogleClassroom]="{url: pageUrl, size: 40, onsharestart: 'onClassroomShare'}"></div>
          </li>
        </ul>
      </div>
    </div>
  </tm-modal-body>
  <tm-modal-footer>
    <div class="location" #tmModalFooter>
      <input type="text" value="{{pageUrl}}" class="fgVQo" readonly="" title="{{'copyLink' | translate}}" (click)="copyToClipBoard($event.target)">
      <span class="cWGXNb">{{'touchToCopyLink' | translate}}</span>
    </div>
  </tm-modal-footer>
</tm-modal>

<!-- <div class="modal fade" id="{{ID}}" tabindex="-1" attr.aria-labelledby="{{ID}}Label" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title sr-only" id="{{ID}}Label">社群分享視窗</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="f3f3f3">
          <div class="col-md-12 social">
            <ul>
              <li><a href="javascript: void(0)" tmShareFacebook
                title="{{'shareTo' | translate: ({value: 'FB'})}}[{{'openNewWindow' | translate}}]">
                <i class="fa fa-lg fa-facebook"></i>
                <span class="sr-only">{{'shareTo' | translate: ({value: 'FB'})}}</span>
              </a></li>
              <li><a href="javascript: void(0)" tmShareTwitter
                title="{{'shareTo' | translate: ({value: 'Twitter'})}}[{{'openNewWindow' | translate}}]">
                <i class="fa fa-lg fa-twitter"></i>
                <span class="sr-only">{{'shareTo' | translate: ({value: 'Twitter'})}}</span>
              </a></li>
              <li><a href="javascript: void(0)" tmShareLine
                title="{{'shareTo' | translate: ({value: 'Line'})}}[{{'openNewWindow' | translate}}]" target="_blank" class="line">
                <i class="fa fa-lg icon-line" aria-hidden="true"></i>
                <span class="sr-only">{{'shareTo' | translate: ({value: 'Line'})}}</span>
              </a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="location">
          <input type="text" value="{{pageUrl}}" class="fgVQo" readonly="" title="複製連結" (click)="copyToClipBoard($event.target)">
          <span class="cWGXNb">輕觸即可複製連結</span>
        </div>
      </div>
    </div>
  </div>
</div> -->